import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAddressValidation, LazyAlertAddressValidation, LazyCustomField, LazyCustomMessages, LazyCustomValidationMessages, LazyDeviceUnlockMuster, LazyDialogFeedbackDeposit, LazyDialogFeedbackPreorder, LazyDialogFeedbackPreorder81, LazyAttachmentFileInput, LazyDateFieldWithPicker, LazyDeliveryStatus, LazyLayoutNotification, LazyUtilsValidatedField, LazyFormCallback, LazyFormContact, LazyFormReturn, LazyInfoContact, LazyInfoContactAddress, LazyInfoDeposit, LazyInfoDepositTransfer, LazyInfoDevice, LazyInfoDeviceCredentials, LazyInfoOrder, LazyInfoReason, LazyProductBuyBack, LazyProductBuyBackItemSelected, LazyProductBuyBackSearchOrder, LazyProductBuyBackStati, LazyProductBuyBackStepCustomerInfo, LazyProductBuyBackStepPaymentOption, LazyProductBuyBackStepRepairParts, LazyCancelationForm, LazySBtn, LazySDivider, LazySFieldLabel, LazySHeaderTitle, LazySInfoMessage, LazySSection, LazySSelectionSummary, LazySStepper, LazyTranslatedFontText, LazyFrequentQuestionsPanel, LazyHelpTopics, LazyKnowledgeBaseExplorer, LazyLanguageBtn, LazyServiceBreadcrumbs, LazyServiceFooter, LazyServiceHome, LazySupportTopics, LazyFAQ, LazyHomeSubmissionForm, LazyHomeSupportRequest, LazyHomeWelcomeFAQ } from '#components'
const lazyGlobalComponents = [
  ["AddressValidation", LazyAddressValidation],
["AlertAddressValidation", LazyAlertAddressValidation],
["CustomField", LazyCustomField],
["CustomMessages", LazyCustomMessages],
["CustomValidationMessages", LazyCustomValidationMessages],
["DeviceUnlockMuster", LazyDeviceUnlockMuster],
["DialogFeedbackDeposit", LazyDialogFeedbackDeposit],
["DialogFeedbackPreorder", LazyDialogFeedbackPreorder],
["DialogFeedbackPreorder81", LazyDialogFeedbackPreorder81],
["AttachmentFileInput", LazyAttachmentFileInput],
["DateFieldWithPicker", LazyDateFieldWithPicker],
["DeliveryStatus", LazyDeliveryStatus],
["LayoutNotification", LazyLayoutNotification],
["UtilsValidatedField", LazyUtilsValidatedField],
["FormCallback", LazyFormCallback],
["FormContact", LazyFormContact],
["FormReturn", LazyFormReturn],
["InfoContact", LazyInfoContact],
["InfoContactAddress", LazyInfoContactAddress],
["InfoDeposit", LazyInfoDeposit],
["InfoDepositTransfer", LazyInfoDepositTransfer],
["InfoDevice", LazyInfoDevice],
["InfoDeviceCredentials", LazyInfoDeviceCredentials],
["InfoOrder", LazyInfoOrder],
["InfoReason", LazyInfoReason],
["ProductBuyBack", LazyProductBuyBack],
["ProductBuyBackItemSelected", LazyProductBuyBackItemSelected],
["ProductBuyBackSearchOrder", LazyProductBuyBackSearchOrder],
["ProductBuyBackStati", LazyProductBuyBackStati],
["ProductBuyBackStepCustomerInfo", LazyProductBuyBackStepCustomerInfo],
["ProductBuyBackStepPaymentOption", LazyProductBuyBackStepPaymentOption],
["ProductBuyBackStepRepairParts", LazyProductBuyBackStepRepairParts],
["CancelationForm", LazyCancelationForm],
["SBtn", LazySBtn],
["SDivider", LazySDivider],
["SFieldLabel", LazySFieldLabel],
["SHeaderTitle", LazySHeaderTitle],
["SInfoMessage", LazySInfoMessage],
["SSection", LazySSection],
["SSelectionSummary", LazySSelectionSummary],
["SStepper", LazySStepper],
["TranslatedFontText", LazyTranslatedFontText],
["FrequentQuestionsPanel", LazyFrequentQuestionsPanel],
["HelpTopics", LazyHelpTopics],
["KnowledgeBaseExplorer", LazyKnowledgeBaseExplorer],
["LanguageBtn", LazyLanguageBtn],
["ServiceBreadcrumbs", LazyServiceBreadcrumbs],
["ServiceFooter", LazyServiceFooter],
["ServiceHome", LazyServiceHome],
["SupportTopics", LazySupportTopics],
["FAQ", LazyFAQ],
["HomeSubmissionForm", LazyHomeSubmissionForm],
["HomeSupportRequest", LazyHomeSupportRequest],
["HomeWelcomeFAQ", LazyHomeWelcomeFAQ],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
